export const menuItems = [
    {
      name: "Getting Started",
      link: "/docs/project",
    },
  ];
  

  export const userMenus = [
    {
      name: "User",
      submenu: 
      [
        {
          name: "Your home",
          link: "/yourHome",
        },          
        {
          name: "Your teams",
          link: "/teams",
        },
        {
          name: "Your web contents",
          link: "/webcontents",
        },
        {
          name: "Sign out",
          link: "/",
        },
      ],
    },
  ];
  
  export const siginMenu = [
    {
      name: "Sign In",
      link: "/signin",
    },
  ];
  